export class RefundPayment {
  constructor(data) {
    this.id = data.id;
  }
}
